// ============================================================
// systems/phase5.js — Phase 5: Escape the Circus (7500+ clicks)
// ============================================================
import { state } from '../state.js';
import { dom } from '../dom.js';
import { stopVoidMusic, startVoidMusic } from '../audio/musicVoid.js';
import { startPhase5Music, stopPhase5Music } from '../audio/musicPhase5.js';
import { playPhase5EntrySound } from '../audio/sfx.js';
import { registerDeactivator } from './bombs.js';

export function activatePhase5() {
  if (state.phase5Active) return;
  state.phase5Active = true;

  // Warning
  dom.phase5Warning.classList.add('show');
  setTimeout(() => dom.phase5Warning.classList.remove('show'), 4000);

  // Visual mode
  document.body.classList.remove('phase4-mode');
  document.body.classList.add('phase5-mode');

  // Plushie becomes bright and escaping — restore original image
  const plushieImgP5 = dom.smiley.querySelector('img');
  if (state.originalPlushieSrc) {
    plushieImgP5.src = state.originalPlushieSrc;
  }
  dom.smiley.classList.remove('greyed');
  dom.smiley.classList.remove('abstracted');
  dom.smiley.classList.add('escaping');

  // Stop void music, start dramatic escape music
  stopVoidMusic();
  dom.phase3Audio.pause();
  if (dom.toggleMusic.classList.contains('on')) {
    startPhase5Music();
  }

  // Entry dramatic sound
  playPhase5EntrySound();

  // Show escape progress bar
  updateEscapeProgress();
}

export function deactivatePhase5() {
  if (!state.phase5Active) return;
  state.phase5Active = false;
  document.body.classList.remove('phase5-mode');
  dom.smiley.classList.remove('escaping');
  stopPhase5Music();
  dom.escapeProgress.style.width = '0%';

  // Restore to phase 4 if still >= 6000
  if (state.score >= 6000 && state.phase4Active) {
    document.body.classList.add('phase4-mode');
    dom.smiley.classList.add('greyed');
    if (dom.toggleMusic.classList.contains('on')) startVoidMusic();
  }
}

export function updateEscapeProgress() {
  if (!state.phase5Active) { dom.escapeProgress.style.width = '0%'; return; }
  const progress = Math.min(((state.score - 7500) / (15000 - 7500)) * 100, 100);
  dom.escapeProgress.style.width = progress + '%';
}

// Register phase5 deactivator so bombs.js can call it without circular import
registerDeactivator('phase5', deactivatePhase5);
